import { localDate } from "./api";

const nowTime = () => new Date().toTimeString().slice(0, 5);
const DEPTS = { optionsFrom: "departments" };

export const FORMS = {
  note: {
    path: "/feed", title: "Manager note", queue: true,
    fields: [
      { name: "text", label: "What's happening?", type: "textarea", required: true, placeholder: "86'd salmon after 8:15 PM. @Kitchen" },
      { name: "priority", label: "Priority", type: "chips", options: ["Normal", "High", "Critical"], default: "Normal" },
      { name: "department", label: "Department", type: "chips", ...DEPTS, more: true },
      { name: "pinned", label: "Pin to Today screen", type: "checkbox", more: true },
      { name: "pin_until", label: "Keep pinned until", type: "date", more: true },
      { name: "requires_ack", label: "Require managers to acknowledge", type: "checkbox", more: true },
      { name: "photos", label: "Photos", type: "photo", more: true },
      { name: "file", label: "Attachment (PDF, doc)", type: "file", more: true },
    ],
  },
  task: {
    path: "/tasks", title: "Task",
    fields: [
      { name: "title", label: "Task", type: "text", required: true, placeholder: "Deep clean bar well 2" },
      { name: "due_date", label: "Due", type: "date", default: () => localDate() },
      { name: "priority", label: "Priority", type: "chips", options: ["Low", "Normal", "High", "Critical"], default: "Normal" },
      { name: "assigned_to", label: "Assign to", type: "user" },
      { name: "department", label: "Department", type: "chips", ...DEPTS, more: true },
      { name: "status", label: "Status", type: "chips", options: ["Open", "In Progress", "Blocked", "Completed"], default: "Open", more: true },
      { name: "recurring", label: "Repeats", type: "chips", options: ["None", "Daily", "Weekly", "Monthly"], default: "None", more: true, help: "Next task is created when this one is completed. Custom schedules aren't supported yet." },
      { name: "notes", label: "Notes", type: "textarea", more: true },
      { name: "photos", label: "Photo / document", type: "photo", more: true },
    ],
  },
  waste: {
    path: "/waste", title: "Waste / spill / breakage", newLabel: "Log Waste", editLabel: "Edit waste entry", queue: true, remember: ["item", "category", "reason", "department"],
    fields: [
      { name: "item", label: "Item", type: "text", required: true, placeholder: "Rocks glass", suggest: "waste_items" },
      { name: "reason", label: "Reason", type: "chips", optionsFrom: "waste_reasons", required: true },
      { name: "value", label: "Estimated value ($)", type: "number", step: "0.01" },
      { name: "quantity", label: "Quantity", type: "number", step: "0.25", default: 1 },
      { name: "department", label: "Department", type: "chips", options: ["Bar", "Kitchen", "FOH"], default: "Bar" },
      { name: "category", label: "Category", type: "select", optionsFrom: "inventory_categories", more: true },
      { name: "employee", label: "Employee", type: "employee", more: true },
      { name: "date", label: "Date", type: "date", default: () => localDate(), more: true },
      { name: "time", label: "Time", type: "time", default: nowTime, more: true },
      { name: "notes", label: "Notes", type: "textarea", more: true },
      { name: "photos", label: "Photo", type: "photo", more: true },
    ],
  },
  incident: {
    path: "/incidents", title: "Incident report", queue: true,
    fields: [
      { name: "type", label: "Type", type: "chips", optionsFrom: "incident_types", required: true },
      { name: "description", label: "What happened?", type: "textarea", required: true },
      { name: "area", label: "Where", type: "chips", optionsFrom: "all_areas" },
      { name: "date", label: "Date", type: "date", default: () => localDate() },
      { name: "time", label: "Time", type: "time", default: nowTime },
      { name: "photos", label: "Photos", type: "photo" },
      { name: "witnesses", label: "Witnesses", type: "text", more: true },
      { name: "manager_notes", label: "Manager notes", type: "textarea", more: true },
      { name: "status", label: "Follow-up status", type: "chips", options: ["Open", "Follow-up", "Closed"], default: "Open", more: true },
    ],
  },
  maintenance: {
    path: "/maintenance", title: "Maintenance issue", queue: true,
    fields: [
      { name: "issue", label: "Issue", type: "text", required: true, placeholder: "Patio heater won't ignite" },
      { name: "priority", label: "Priority", type: "chips", options: ["Low", "Normal", "High", "Critical"], default: "Normal" },
      { name: "area", label: "Location", type: "chips", optionsFrom: "all_areas" },
      { name: "photos", label: "Photo", type: "photo" },
      { name: "assigned_to", label: "Assigned person / vendor", type: "text", more: true },
      { name: "status", label: "Status", type: "chips", options: ["Open", "In Progress", "Resolved"], default: "Open", more: true },
    ],
  },
  item86: {
    path: "/items86", title: "86 an item", queue: true, remember: ["item"],
    fields: [
      { name: "item", label: "Item", type: "text", required: true, placeholder: "Salmon" },
      { name: "note", label: "Note", type: "text", placeholder: "Back tomorrow", more: true },
      { name: "active", type: "hidden", default: true },
    ],
  },
  guest: {
    path: "/guest-issues", title: "Guest issue", queue: true,
    fields: [
      { name: "issue", label: "Issue", type: "text", required: true },
      { name: "table", label: "Table #", type: "text" },
      { name: "resolution", label: "Resolution", type: "text" },
      { name: "compensation", label: "Compensation given", type: "text", more: true },
      { name: "guest_name", label: "Guest name", type: "text", more: true },
      { name: "follow_up", label: "Follow-up required", type: "checkbox", more: true },
      { name: "status", type: "hidden", default: "Open" },
    ],
  },
  beo: {
    path: "/beos", title: "Large party / BEO", newLabel: "New Event / BEO", editLabel: "Edit event / BEO", remember: ["room", "event_type", "arrival_time", "start_time", "end_time"],
    fields: [
      { name: "event_name", label: "Event name", type: "text", required: true },
      { name: "event_date", label: "Event date", type: "date", required: true },
      { name: "guest_count", label: "Guest count", type: "number" },
      { name: "guest_name", label: "Contact name", type: "text" },
      { name: "phone", label: "Phone", type: "tel" },
      { name: "status", label: "Status", type: "chips", options: ["Inquiry", "Tentative", "Confirmed", "Deposit Paid", "Completed", "Cancelled"], default: "Inquiry" },
      { name: "room", label: "Room / area", type: "chips", optionsFrom: "areas", remember: true },
      { name: "email", label: "Email", type: "email", more: true },
      { name: "company", label: "Company", type: "text", more: true },
      { name: "event_type", label: "Event type", type: "text", more: true },
      { name: "arrival_time", label: "Arrival", type: "time", more: true },
      { name: "start_time", label: "Start", type: "time", more: true },
      { name: "end_time", label: "End", type: "time", more: true },
      { name: "food_selections", label: "Food selections", type: "textarea", more: true },
      { name: "beverage_selections", label: "Beverage selections", type: "textarea", more: true },
      { name: "dietary", label: "Dietary restrictions", type: "text", more: true },
      { name: "allergies", label: "Allergies", type: "text", more: true },
      { name: "special_requests", label: "Special requests", type: "textarea", more: true },
      { name: "deposit_amount", label: "Deposit amount ($)", type: "number", more: true },
      { name: "deposit_status", label: "Deposit status", type: "chips", options: ["Not requested", "Pending", "Paid", "Refunded"], more: true },
      { name: "minimum_spend", label: "Minimum spend ($)", type: "number", more: true },
      { name: "estimated_total", label: "Estimated total ($)", type: "number", more: true },
      { name: "final_total", label: "Final total ($)", type: "number", more: true },
      { name: "timeline", label: "Event timeline", type: "textarea", more: true },
      { name: "notes", label: "Notes (guest-facing)", type: "textarea", more: true },
      { name: "internal_notes", label: "Internal manager notes", type: "textarea", more: true },
    ],
  },
  employee: {
    path: "/employees", title: "Employee",
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "role", label: "Position", type: "chips", optionsFrom: "positions" },
      { name: "department", label: "Department", type: "chips", ...DEPTS },
      { name: "status", label: "Status", type: "chips", options: ["Active", "Pending", "Leave", "Inactive"], default: "Active" },
      { name: "preferred_name", label: "Preferred name", type: "text", more: true },
      { name: "email", label: "Email", type: "email", more: true },
      { name: "phone", label: "Phone", type: "tel", more: true },
    ],
  },
  document: {
    path: "/documents", title: "Document",
    fields: [
      { name: "file", label: "File", type: "file" },
      { name: "name", label: "Name", type: "text", required: true },
      { name: "folder", label: "Folder", type: "chips", optionsFrom: "document_folders" },
      { name: "notes", label: "Notes", type: "textarea", more: true },
    ],
  },
  inventoryItem: {
    path: "/inventory-items", title: "Inventory item",
    fields: [
      { name: "name", label: "Item", type: "text", required: true },
      { name: "category", label: "Category", type: "chips", optionsFrom: "inventory_categories", required: true },
      { name: "unit", label: "Unit", type: "chips", options: ["bottle", "case", "keg", "each", "lb", "gallon"], default: "bottle" },
      { name: "par", label: "Par", type: "number", step: "0.25" },
      { name: "unit_cost", label: "Unit cost ($)", type: "number", step: "0.01" },
      { name: "expected", label: "Expected on hand", type: "number", step: "0.25", more: true },
      { name: "notes", label: "Notes", type: "text", more: true },
    ],
  },
};
